export const LOGIN_URL = '/user/login';
export const LOGIN_URL_REGEXP = new RegExp(LOGIN_URL.replace('/', '/'));
export const CONFIRM_URL = '/user/confirm';
export const RESET_PASSWORD_URL = '/reset-password';
export const REGISTRATION_STANDALONE = '/user/onboard';
